import { Component, Injector, OnInit } from '@angular/core';
import { ActiveModal, ChassisFormHandler } from '@kaiser-software/chassis-core';
import 'rxjs/add/operator/finally';
import { KpiModal } from '../kpi-modal';

@Component({
    selector: 'app-kpis-kpis-create-modal',
    templateUrl: 'create-kpi.modal.html',
    styleUrls: [ 'create-kpi.modal.scss' ]
})
export class CreateKpiModal extends KpiModal implements OnInit {

    private title = 'Add key performance indicator';

    constructor(protected injector: Injector, protected modal: ActiveModal) {
        super(injector, modal);
    }

    ngOnInit() {
        this.model = this.kpiSetKpiService.make();

        super.ngOnInit();

        this.modal.set('title', this.title);

        this.createForm();
    }

    private createForm(): void {
        this.form = new ChassisFormHandler(this.injector, this.kpiService.entityName, this.model);
    }

    protected setModalButtons() {
        super.setModalButtons();
    }

    protected setSubmitModalButton(buttons: Map<string, any>) {
        super.setSubmitModalButton(buttons);
    }

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/kpis/modals/create-kpi/create-kpi.modal.ts